import { render, staticRenderFns } from "./UploadDocumentsModal.vue?vue&type=template&id=4231d534"
import script from "./UploadDocumentsModal.vue?vue&type=script&lang=ts"
export * from "./UploadDocumentsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports